import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

const CTAAnnotation = ({ data }) => {
  const insured = get(
    data,
    'product.institution.details.federally_insured.value',
    null
  );
  const name = get(data, 'product.institution.details.display_name.value');

  let FDICStatus;
  if (insured) {
    FDICStatus = `Member ${insured}`;
  }

  return (
    <div className="annotation-apply">
      At {name}
      {FDICStatus && ', '}
      {FDICStatus}
    </div>
  );
};

CTAAnnotation.propTypes = {
  data: PropTypes.shape({
    product: PropTypes.shape({
      institution: PropTypes.shape({
        details: PropTypes.shape({
          federally_insured: PropTypes.shape({
            value: PropTypes.string,
          }),
          display_name: PropTypes.shape({
            value: PropTypes.string,
          }),
        }),
      }),
    }),
  }),
};

CTAAnnotation.displayName = 'CTAAnnotation';

export default CTAAnnotation;
